'use client';

import { cn } from '../_lib/utils';
import { Form } from '../Form';

export type SimpleFormProps = {
	className?: string;
	hubspotFormId?: string;
	title?: string;
	copy?: string;
	label?: string;
	buttonText?: string;
	successHeading?: string;
	successMessage?: string;
	emailAddress?: string;
	colourMode?: string;
};

export function SimpleForm(props: SimpleFormProps) {
	return (
		<article data-component='SimpleForm' className={cn('container-sm', props.className)}>
			<div
				className={cn(
					'flex flex-col gap-40 rounded-lg bg-background-white py-5 text-center',
					props.colourMode === 'darkMode' ? 'bg-card-background-primary' : 'bg-background-white',
				)}
				data-header-ignore
				data-theme={props.colourMode === 'darkMode' ? 'dark' : 'light'}
			>
				<Form
					hubspotFormId={props.hubspotFormId}
					title={props.title}
					copy={props.copy}
					label={props.label}
					buttonText={props.buttonText}
					successHeading={props.successHeading}
					successMessage={props.successMessage}
					emailAddress={props.emailAddress}
				/>
			</div>
		</article>
	);
}
